/** CRA `homepage` / `PUBLIC_URL` — empty string for root domain (e.g. staff.aspenhealth.sg). */
export const APP_BASENAME = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
